module.exports = __webpack_public_path__ + "static/media/logo.aa74e425.png";